/**
 * All "My shipment" table columns. Each column has an `id` (used as a key and for
 * sorting), `label` (the header column text), `width` (how wide the column should
 * be in pixels), and `alignment` (which side the column's content "sticks" to).
 */

import { convertParentChild } from "../components/Constants";

const nyrTableColumns = [
  {
    id: "tempZone",
    label: "Temp Zone",
    width: 110,
    alignment: "center",
  },
  {
    id: "asin",
    label: "ASIN",
    width: 110,
    alignment: "center",
  },
  {
    id: "child_asin",
    label: "Child ASIN",
    width: 110,
    alignment: "center",
  },
  {
    id: "asinTitle",
    label: "Product Name",
    width: 220,
    alignment: "center",
  },
  {
    id: "quantityConfirmed",
    label: "Expected Qty Parent",
    width: 150,
    alignment: "center",
  },
  {
    id: "vendorConfirmedUnits",
    label: `Expected Qty${convertParentChild === 1 ? ' Child' : ''}`,
    width: 150,
    alignment: "center",
  },
  {
    id: "vendorReceivedUnits",
    label: `Received Qty${convertParentChild === 1 ? ' Child' : ''}`,
    width: 150,
    alignment: "center",
  },
  {
    id: "backlog",
    label: `NYR Qty${convertParentChild === 1 ? ' Child' : ''}`,
    width: 150,
    alignment: "center",
  },
  {
    id: "isCriticalAsin",
    label: "Critical ASIN",
    width: 150,
    alignment: "center",
  },
  {
    id: "isAsrsAsin",
    label: "ASRS ASIN",
    width: 150,
    alignment: "center",
  },
]

export const defaultNYRTableColumns = nyrTableColumns.reduce(
  (columns, column) => ({
    ...columns,
    [column.id]: true,
  }),
  {}
)

export const getNYRTableColumnById = id =>
  nyrTableColumns.find(column => column.id === id)

export default nyrTableColumns
